import { render, staticRenderFns } from "./MonitorWork.vue?vue&type=template&id=461f568f&scoped=true"
import script from "./MonitorWork.vue?vue&type=script&lang=js"
export * from "./MonitorWork.vue?vue&type=script&lang=js"
import style0 from "./MonitorWork.vue?vue&type=style&index=0&id=461f568f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461f568f",
  null
  
)

export default component.exports